module.exports = __webpack_public_path__ + "static/install_license_terms-828aef775e91ed989084ea9b7911ee3e.png";